import React from 'react'
import classes from '../styles.module.scss';
import { infoData } from '../../../../consts/other.conts';
import { useTranslation } from 'react-i18next';
import { ChevronRightIcon } from '../../../../assets/icons';
import { useKato } from '../../../../contexts/kato.context';
import { useNavigate, useParams } from 'react-router-dom';

export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');       // "01"
    const month = String(date.getMonth() + 1).padStart(2, '0'); // "01"
    const year = date.getFullYear();                            // 2025

    return `${day}.${month}.${year}`;
};

export const Info = () => {
    const { t } = useTranslation();
    const { generalInfo } = useKato().katoGeneralInfo;
    const navigate = useNavigate();
    const { kato } = useParams<{ kato: string }>();
    if (!generalInfo) return null;

    return (
        <div className={classes.info}>
            {infoData.map((item) => (
                <div className={classes.info__item} key={item.valueKey}>
                    <div className={classes.info__icon}>
                        {item.icon}
                    </div>
                    <div className={classes.info__title}>
                        <span>{t(item.title)}</span>
                        <span>{t("snp-info.na", { date: formatDate(generalInfo.date) })}</span>
                    </div>
                    <div className={classes.info__value}>
                        <span>{generalInfo[item.valueKey]?.toLocaleString('ru')}</span>
                        <span>{t(item.valueSuffix)}</span>
                    </div>
                    <div className={classes.info__icon} onClick={() => navigate(`/${kato}/indicators`)}>
                        {<ChevronRightIcon />}
                    </div>
                </div>
            ))}
        </div>
    )
}
